import { useEffect, useState } from 'react';

import { useMap } from '@strava/ui/Map/useMap';

export const useRerenderOnMapStyleLoad = () => {
  const map = useMap();
  const [, forceRender] = useState({});

  useEffect(() => {
    const onStyleLoad = () => forceRender({});
    map?.on('style.load', onStyleLoad);

    return () => {
      map?.off('style.load', onStyleLoad);
    };
  }, [map]);

  return null;
};

export default useRerenderOnMapStyleLoad;
